/** Sentinel: no metric column — backend uses a constant/count metric. */
export const MAP_NO_METRIC = '__manteo_no_metric__';
export const MAP_VALUE_PLACEHOLDER = '__manteo_constant_metric__';

/** API payload for uniform maps (empty column → server constant metric). */
export const CLEARED_MAP_VALUE = { column: '', aggregation: 'count' };

export const metricColumnFromSpec = (value) => {
  const col = value?.column;
  if (!col || col === MAP_VALUE_PLACEHOLDER) return MAP_NO_METRIC;
  return col;
};

export const isNumericColumnType = (colType) => {
  const upper = (colType || 'STRING').toUpperCase();
  const exact = [
    'INTEGER', 'INT64', 'FLOAT', 'FLOAT64', 'NUMERIC', 'BIGNUMERIC', 'DECIMAL',
    'BIGINT', 'SMALLINT', 'TINYINT', 'DOUBLE', 'REAL'
  ];
  if (exact.includes(upper)) return true;
  return ['INT', 'FLOAT', 'DOUBLE', 'NUMERIC', 'DECIMAL', 'REAL'].some((k) => upper.includes(k));
};

export const isNumericColumn = (colName, columns = []) => {
  const col = columns.find((c) => c.name === colName);
  return col ? isNumericColumnType(col.type) : false;
};

export const buildQueryValue = (valueColumn, aggregation) => {
  if (!valueColumn || valueColumn === MAP_NO_METRIC) return { ...CLEARED_MAP_VALUE };
  return { column: valueColumn, aggregation: aggregation || 'count' };
};

export const defaultAggregationForColumn = (valueColumn, columns, currentAgg) => {
  if (!valueColumn || valueColumn === MAP_NO_METRIC) return 'count';
  const numeric = isNumericColumn(valueColumn, columns);
  if (numeric) return currentAgg || 'sum';
  if (['count', 'min', 'max'].includes(currentAgg)) return currentAgg;
  return 'min';
};
